import { render, staticRenderFns } from "./productBoxOptions.vue?vue&type=template&id=67815d3b"
import script from "./productBoxOptions.vue?vue&type=script&lang=js"
export * from "./productBoxOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports